import PropTypes from "prop-types";
import {useState} from "react";


export default function CellView(props) {
    const [isHovered, setIsHovered] = useState(false)

    const [isExpanded, setIsExpanded] = useState(false)


    function classNames(...classes) {
        return classes.filter(Boolean).join(' ')
    }

    let project = props.project
    let product = project

    return (
        <div>
            <div className="relative">
                <div className="rounded-xl">
                    <div className={classNames("", "rounded h-72 w-full bg-cover bg-center bg-no-repeat relative")}
                         style={{
                             backgroundImage: `url(${product.imageSrc})`,
                             backgroundPosition: `50% ${product.imageStartPosition}`  // Adjust the percentage to your liking
                         }}>
                        <div className="absolute inset-0 bg-gradient-to-t from-black via-transparent to-transparent opacity-75"></div>
                    </div>
                </div>
                <div className="relative mt-4">
                    <h3 className="text-xl text-gray-900 custom-font">{product.name}</h3>
                    <p className="text-base text-gray-800">{product.description}</p>
                </div>
                <div
                    className="absolute inset-x-0 top-0 flex h-72 items-end justify-end overflow-hidden rounded-lg p-4">
                    <div
                        aria-hidden="true"
                        className="absolute inset-x-0 bottom-0 h-36 bg-linear-to-t from-black opacity-50"
                    />
                    <p className="relative text-lg font-semibold text-white">${product.cost}</p>
                </div>
            </div>
            <div className="mt-6">
                <button
                    className="w-full relative flex items-center justify-center rounded-md border border-transparent bg-gray-100 px-8 py-2 text-sm font-medium text-gray-900 hover:bg-gray-200"
                    onClick={() => {props.setIsSelected(!props.isSelected)}}
                >
                    {/*Add to cart*/}
                    {
                        !Boolean(props.isSelected) ? "Add to cart" : checkedButton()
                    }
                </button>
            </div>
        </div>
)

    return (
        <div className="flex"
             onMouseEnter={() => {
                 setIsHovered(true)
             }}
             onMouseLeave={() => {
                 setIsHovered(false)
             }}
             onClick={() => props.setIsSelected(!props.isSelected)}
        >
            <div
                className={classNames(
                    project.bgColor,
                    'flex w-16 flex-shrink-0 items-center justify-center rounded-l-md text-sm font-bold text-white text-center',
                )}
            >
                {isHovered ? <div>${project.cost}</div> : <div> {project.hours} < br/> HOURS </div>}
            </div>
            <div
                className="flex flex-1 items-center justify-between truncate rounded-r-md border-b border-r border-t border-gray-200 bg-white"
                onClick={() => props.setIsSelected(true)}
            >
                <div className="flex-1 truncate px-4 py-2">
                    <div className="text-gray-500">{project.name}</div>
                    <div>
                        <div className="flex space-x-4 text-gray-500 text-sm" onClick={() => {
                            alert("Added to cart")  // TODO: This should be a toast
                            // TODO: Add to cart
                        }}>
                            <div>
                                Stars: {project.rating}
                            </div>
                            <div>
                                Cost: ${project.cost}
                            </div>
                        </div>
                        <p className={classNames(isHovered ? "line-clamp-5" : "line-clamp-1", "text-wrap text-gray-500 text-sm")} onClick={() => {
                            alert("Added to cart")  // TODO: This should be a toast
                            // TODO: Add to cart
                        }}>
                            Blurb: {project.description}
                        </p>
                    </div>
                </div>
                <div className="flex-shrink-0 pr-2">
                    <button
                    >
                        {
                            !Boolean(props.isSelected) ? addButton() : checkedButton()
                        }

                    </button>
                </div>
            </div>
        </div>
    )


    function addButton() {

        return (

            <button
                type="button"
                className="inline-flex items-center gap-x-1.5 rounded-md bg-gray-900 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
            >
                <div className="flex items-center justify-center gap-1">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                         stroke="currentColor" className="size-6">
                        <path stroke-linecap="round" stroke-linejoin="round"
                              d="M12 9v6m3-3H9m12 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"/>
                    </svg>
                    <div className="text-sm">
                        Add
                    </div>
                </div>
            </button>
        )
    }

    function checkedButton() {
        return (
            <div onClick={() => props.setIsSelected(!props.isSelected)}>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
                     className="size-6">
                    <path fill-rule="evenodd"
                          d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm13.36-1.814a.75.75 0 1 0-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 0 0-1.06 1.06l2.25 2.25a.75.75 0 0 0 1.14-.094l3.75-5.25Z"
                          clip-rule="evenodd"/>
                </svg>
            </div>
        )
    }
}


CellView.propTypes = {
    isSelected: PropTypes.bool,
    setIsSelected: PropTypes.func,
    project: PropTypes.object.isRequired,
    title: PropTypes.string,
    displayablePrice: PropTypes.string,

    status: PropTypes.string,
}
